"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _base = _interopRequireDefault(require("./../base"));

var _copyright2 = _interopRequireDefault(require("./copyright"));

var _encoding = _interopRequireDefault(require("./encoding"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Asset = /*#__PURE__*/function (_Base) {
  (0, _inherits2.default)(Asset, _Base);

  var _super = _createSuper(Asset);

  function Asset() {
    (0, _classCallCheck2.default)(this, Asset);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Asset, [{
    key: "template",
    get: function get() {
      return {
        copyright: function copyright(_copyright) {
          return new _copyright2.default(_copyright);
        },
        imageEncodings: function imageEncodings(encoding) {
          return new _encoding.default(encoding);
        }
      };
    }
  }]);
  return Asset;
}(_base.default);

exports.default = Asset;
module.exports = exports.default;